export default class StringMatch {
  public static match(left: string, right: string): boolean {
    return left.toLowerCase().trim().includes(right.toLowerCase().trim());
  }
}
